import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { TournamentList } from 'actions/actionTypes';
import * as actions from 'actions/tournament/list';

import { callTournamentList, callDeleteTournament, callEarlyEndTournament } from 'network/apis/tournament/list';

// 매장 대회 목록 조회 사가 함수
function* loadTournamentListRequestSaga() {
    try {
        const tournamentList = yield select((state) => state.tournamentList);

        var data = {
            page: tournamentList.filterData.page,
            pageSize: tournamentList.filterData.pageSize,
            tournamentTypeCode: tournamentList.filterData.tournamentTypeCode,
            tournamentStatus: tournamentList.filterData.tournamentStatus,
        };

        const response = yield call(callTournamentList, data);

        yield put(actions.loadTournamentListRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadTournamentListRequestFailure(error.message));
    }
}

// 매장 대회 삭제 사가 함수
function* deleteTournamentRequestSaga() {
    try {
        const tournamentList = yield select((state) => state.tournamentList);

        const response = yield call(callDeleteTournament, tournamentList.tournamentId);

        yield put(actions.deleteTournamentRequestSuccess());
    } catch (error) {
        yield put(actions.deleteTournamentRequestFailure(error.message));
    }
}

// 매장 대회 조기 종료 사가 함수
function* earlyEndTournamentRequestSaga() {
    try {
        const tournamentList = yield select((state) => state.tournamentList);

        const response = yield call(callEarlyEndTournament, tournamentList.tournamentId);

        yield put(actions.earlyEndTournamentRequestSuccess());
    } catch (error) {
        yield put(actions.earlyEndTournamentRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([takeLatest(TournamentList.LOAD_TOURNAMENT_LIST_REQUEST, loadTournamentListRequestSaga), takeLatest(TournamentList.DELETE_TOURNAMENT_REQUEST, deleteTournamentRequestSaga), takeLatest(TournamentList.EARLY_TOURNAMENT_REQUEST, earlyEndTournamentRequestSaga)]);
}
